import news from './enNews';
export default {
    message: {
        bandName: 'Lunatic Tone Orchestra',
        mailAddress: 'progressive-philosophy@kyousou-gakudan.com',
        copyRight: 'Copyright © 2007-{thisYear} Lunatic Tone Orchestra. All Rights Reserved.',
        description: 'Lunatic Tone Orchestra - 2020 Reborn. Our sound was influenced by a such as Metal, Visual kei, Progressive rock and Djent. Major themes in the our music included life and death, religion, how the society should be, and so on. We are a Progressive Philosophy band.',
        // 各ページ用の情報
        information: {
            pageName: 'Information',
            buy: 'BUY NOW',
            whatsNews: news,
            event: {
                title: 'EVENTS',
                done: 'Thanks!',
                events: { // 応募予定: We will be applying. 応募中:Still choosing.
                    e1:{
                        name: 'Comic Market 106',
                        date: 'Aug 16-17, 2025',
                        space: 'Sunday West ま-47a',
                        yyyymmdd: '20250817',
                        url:'https://webcatalog.circle.ms/Perma/Circle/10026407/',
                    },
                    e2:{
                        name: 'M3 2025 Autumn',
                        date: '2025.10.26',
                        space: 'Still choosing.',
                        yyyymmdd: '20251026',
                        url:'https://www.m3net.jp/',
                    },
                },
                snsWarning: "You may not be able to view your Depending on your ad blocker or login status to the service.",
            },
        },
        biography: {
            pageName: 'Biography',
            description: 'This page contains biography and members information of the Lunatic Tone Orchestra.',
            band: {
                title: 'Band',
                explanation: `In 2007, We formed band in Yokohama Japan with Sakiai as the leader.<br>
                Our sound was influenced by a such as Metal, Visual kei, Progressive rock and Djent. Major themes in the our music included life and death, religion, how the society should be, and so on.<br>
                All songs are Sakiai's philosophy. We call our songs Progressive Philosophy.<br>
                We use a standard band format of mixed vocals, 7-string guitar, 5-string bass, drums, we often use such as violins, pianos, organs.<br>
                From 2007 to 2012, we sold CDs mainly at Comic Market and M3.<br>
                In 2012, Suspended activities.<br>
                In October 2020, Reborn.<br>
                "Chronicle Of Faith" was released on Dec 31, 2021.<br>
                "DEMO CD FÜNF HEXEN(tentative) #1" was released on Oct 30, 2022.<br>
                "DEMO CD FÜNF HEXEN(tentative) #2" was released on Apr 30, 2023.<br>
                "DEMO CD FÜNF HEXEN DEMO #3" was released on Apr 27, 2025.<br>
                "FIFTH WITHES -The essence of foolish people has continued since the primordial, A causal savior is finally born-" will be released in 2025.<br>
                `,
            },
            members: {
                pageName: 'Member',
                list: {
                    m01: {
                        name: 'Sakiai',
                        role: ['Composition and lyrics', 'Guitar', 'Bass', 'Vocals...'],
                        twitter: '',
                        instagram: '',
                        bluesky: '',
                        threads: '',
                    },
                    m02: {
                        name: 'Kei',
                        role: ['Vocals'],
                        twitter: '',
                        instagram: '',
                        bluesky: '',
                        threads: '',
                    },
                    m03: {
                        name: 'Hisui',
                        role: ['Vocals'],
                        twitter: '',
                        instagram: '',
                        bluesky: '',
                        threads: '',
                    },
                    m04: {
                        name: 'Cadaver',
                        role: ['Drums'],
                        twitter: 'catdayversion',
                        instagram: '',
                        bluesky: '',
                        threads: '',
                    },
                    m05: {
                        name: 'M',
                        role: ['Design', 'Web Design...'],
                        twitter: 'm150mmmm',
                        instagram: 'm150_mmmm',
                        bluesky: 'm150mmmm.bsky.social',
                        threads: 'm150_mmmm',
                    }
                },
            },
        },
        discography: {
            pageName: 'Discography',
            description: 'This page contains albums information of the Lunatic Tone Orchestra.',
            albums: {
                a10: {
                    id: 10,
                    name: 'Prologue',
                    description: 'Prologue by Lunatic Tone Orchestra released on Aug 14, 2010',
                    date: 'Aug 14, 2010',
                    event: 'Comic market 78',
                    price: 100,
                    priceDl: 100,
                    priceShop: '',
                    advertisingSlogan: '神の所為で人が死ぬ 人は何に縋る<br>人が死にに往く 信仰の為に<br>神は喜んでいるか？',
                    infoDemo: '1_the_world',
                    infoDemoTitle: 'The World',
                    tracks: {
                        t01: {
                            name: 'The World',
                            demo: '1_the_world',
                        },
                        t02: {
                            name: 'Vampire',
                            demo: '',
                        },
                        t03: {
                            name: 'Shisuru otome no namida',
                            demo: '',
                        },
                        t04: {
                            name: 'Kotori',
                            demo: '4_kotori',
                        },
                        t05: {
                            name: 'The Empress',
                            demo: '5_the_empress',
                        },
                    },
                },
                a11: {
                    id: 11,
                    name: 'Tumitugaru syuguno kokugouha saidohakanaki rintenno toga',
                    description: 'Tumitugaru syuguno kokugouha saidohakanaki rintenno toga by Lunatic Tone Orchestra released on Dec 31, 2010',
                    date: 'Dec 31, 2010',
                    event: 'Comic market 79',
                    price: 500,
                    priceDl: 500,
                    priceShop: '',
                    advertisingSlogan: '告発者は探し続ける罪を犯す咎人を 観自在に満眸の有涯を其の明眼で視る<br>貴方は唯罪を犯した 貴方は唯人を殺した',
                    infoDemo: 'crossfade',
                    infoDemoTitle: 'crossfade',
                    tracks: {
                        t01: {
                            name: 'Tumi no waisa',
                            demo: '',
                        },
                        t02: {
                            name: 'Santanto eguru kokuhatusyaha reikokuna akashibitoto',
                            demo: '2_santanto_eguru_kokuhatusyaha_reikokuna_akashibitoto',
                        },
                        t03: {
                            name: 'Syutanno kaouteisu danzaisya',
                            demo: '3_syutanno_kaouteisu_danzaisya',
                        },
                        t04: {
                            name: 'Kansokusya seku wadatumi kakae',
                            demo: '',
                        },
                        t05: {
                            name: 'Nejino toga',
                            demo: '',
                        },
                    },
                },
                a12: {
                    id: 12,
                    name: 'Alice Corpse',
                    description: 'Alice Corpse by Lunatic Tone Orchestra released on Aug 13, 2011',
                    date: 'Aug 13, 2011',
                    event: 'Comic market 80',
                    price: 1000,
                    priceDl: 1000,
                    priceShop: '',
                    advertisingSlogan: '「今の暮らしは楽しいか？」<br>君を極彩の園に誘おう 其処は楽しく愉快で美しい楽園だ<br>失い気付く日々の平穏さ鼬の道と 深省し悔恨する涙濡ち暗澹たる心持で走る',
                    infoDemo: 'crossfade',
                    infoDemoTitle: 'crossfade',
                    tracks: {
                        t01: {
                            name: '[All in the golden afternoon...]',
                            demo: '',
                        },
                        t02: {
                            name: 'AT REST',
                            demo: '02_at_rest',
                        },
                        t03: {
                            name: 'Kyoo',
                            demo: '',
                        },
                        t04: {
                            name: 'Gokusaisikino doukei',
                            demo: '04_gokusaisikino_doukei',
                        },
                        t05: {
                            name: '[To wonderland...]',
                            demo: '',
                        },
                        t06: {
                            name: 'Nitizyokara ideru yamiwo nukete itaru hikarino rakuen',
                            demo: '',
                        },
                        t07: {
                            name: 'Masyono sono',
                            demo: '07_masyono_sono',
                        },
                        t08: {
                            name: 'Mad Tea Party',
                            demo: '',
                        },
                        t09: {
                            name: '[The witch\'s game...]',
                            demo: '',
                        },
                        t10: {
                            name: 'Rasen taidan',
                            demo: '',
                        },
                        t11: {
                            name: 'blAcKJQ',
                            demo: '',
                        },
                        t12: {
                            name: 'The Balance Of Life.',
                            demo: '12_the_balance_of_life',
                        },
                        t13: {
                            name: '[They told me you had been to her...]',
                            demo: '',
                        },
                        t14: {
                            name: 'Koganeirono jokei',
                            demo: '',
                        },
                        t15: {
                            name: 'Saigono ganbou',
                            demo: '',
                        },
                        t16: {
                            name: 'Alice Corpse',
                            demo: '',
                        },
                    },
                    remix: '2022 Remix AT REST',
                    remixDl: '2022 Remix AT REST Free distribution at BOOTH',
                },
                a13: {
                    id: 13,
                    name: '"Akaguroi otukisama Aojiroi ohisama"',
                    description: '"Akaguroi otukisama Aojiroi ohisama" by Lunatic Tone Orchestra released on Aug 11, 2012',
                    date: 'Aug 11, 2012',
                    event: 'Comic market 82',
                    price: 300,
                    priceDl: 300,
                    priceShop: '',
                    advertisingSlogan: '「殻に覆われあの日見た白に透ける青は綺麗だった」<br>「蹣跚めき攀じる階の先に開ける赤の血 ほろに別る骸亡き魂昇る黒の世」',
                    infoDemo: '03_sekitino_hakoniwa_karatiribame_tobimau_kokutenno_moto_ukasu_hane',
                    infoDemoTitle: 'Sekitino hakoniwa karatiribame tobimau kokutenno moto ukasu hane',
                    tracks: {
                        t01: {
                            name: 'Shirakumono youran karatiribamete haitukubau seitenno moto fukasu ashi',
                            demo: '01_shirakumono_youran_karatiribamete_haitukubau_seitenno_moto_fukasu_ashi',
                        },
                        t02: {
                            name: '"Aojiroi ohisama"',
                            demo: '',
                        },
                        t03: {
                            name: 'Sekitino hakoniwa karatiribame tobimau kokutenno moto ukasu hane',
                            demo: '03_sekitino_hakoniwa_karatiribame_tobimau_kokutenno_moto_ukasu_hane',
                        },
                        t04: {
                            name: '"Akaguroi otukisama"',
                            demo: '',
                        },
                    },
                },
                a14: {
                    id: 14,
                    name: 'Chronicle Of Faith',
                    description: 'Chronicle Of Faith by Lunatic Tone Orchestra released on Dec 31, 2021',
                    date: 'Dec 31, 2021',
                    event: 'Comic market 99',
                    price: 1000,
                    priceDl: 1000,
                    priceShop: '',
                    advertisingSlogan: 'それでも神様はいるんだよね？',
                    infoDemo: 'crossfade',
                    infoDemoTitle: 'crossfade',
                    tracks: {
                        t01: {
                            name: 'Still, there is a God?',
                            demo: '01_soredemo_kamisamaha_irundayone',
                        },
                        t02: {
                            name: 'Red Sacrifice',
                            demo: '',
                        },
                        t03: {
                            name: 'Sorrowful Love Poems',
                            demo: '03_hirenka',
                        },
                        t04: {
                            name: 'Tenrai',
                            demo: '04_tenrai',
                        },
                        t05: {
                            name: 'Machinetism',
                            demo: '',
                        },
                        t06: {
                            name: 'Decapitation God',
                            demo: '',
                        },
                        t07: {
                            name: 'Song of Doomsday',
                            demo: '',
                        },
                    },
                },
                a15: {
                    id: 15,
                    name: 'FIFTH WITHES -The essence of foolish people has continued since the primordial, A causal savior is finally born-',
                    description: 'FIFTH WITHES -The essence of foolish people has continued since the primordial, A causal savior is finally born- by Lunatic Tone Orchestra expected to go on sale in the 2024',
                    date: 'Aug 17, 2025',
                    event: 'Comic market 106',
                    price: 1500,
                    priceDl: 1500,
                    priceShop: '',
                    advertisingSlogan: '産祝へ<br>「無窮の済度遣す魔法如く全能たる淑女」',
                    infoDemo: '02_Witch_of_Creation',
                    infoDemoTitle: 'Witch of Creation',
                    tracks: {
                        t01: {
                            name: 'A causal savior is finally born',
                            demo: '',
                        },
                        t02: {
                            name: 'Witch of Creation',
                            demo: '02_Witch_of_Creation',
                        },
                        t03: {
                            name: 'Witch of True',
                            demo: '',
                        },
                        t04: {
                            name: 'Witch of Value',
                            demo: '',
                        },
                        t05: {
                            name: 'Witch of Life',
                            demo: '',
                        },
                        t06: {
                            name: 'Witch of Eternal',
                            demo: '',
                        },
                        t07: {
                            name: 'The essence of foolish people has continued since the primordial',
                            demo: '',
                        },
                    },
                },
            },
            price: 'Price: {price} Yen',
            priceDl: 'Download sale Price: {price} Yen(Tax excluded)',
            priceShop: 'Consignment Price: {price} Yen(Tax excluded)',
            priceToBeDetermined: 'Price: TBD',
            dlSale: 'Download sale',
            sale: 'Consignment Sale',
            crossfade: 'Crossfade Demo',
            specialThanks: 'Special Thanks',
            movie: 'Movie',
        },
        demo: {
            pageName: 'Demo CD',
            description: 'This page contains Demo tracks information of the Lunatic Tone Orchestra.',
            free: 'Free Distribution at BOOTH',
            freeShort: 'Free Distribution',
            list: {
                demo1: {
                    id: 1,
                    name: 'FÜNF HEXEN (tentative) #1',
                    date: '30 Okt 2022',
                    event: 'M3 2022 Herbst',
                    booth: 'https://kyousou-gakudan.booth.pm/items/4272625',
                    tracks: {
                        t1: 'Geschichte Hexe (tentative) Demo',
                        t2: 'Goldnugget Hexe (tentative) Demo',
                    },
                    youtube: ['y-Uso4tdjEc'],
                    youtubeShort: [],
                },
                demo2: {
                    id: 2,
                    name: 'FÜNF HEXEN (tentative) #2',
                    date: '30 Apr 2023',
                    event: 'M3 2023 Frühling',
                    booth: 'https://kyousou-gakudan.booth.pm/items/4738776',
                    tracks: {
                        t1: 'Wahrheit Hexe (tentative) Demo',
                        t2: 'Unsterbliche Hexe (tentative) Demo',
                    },
                    youtube: ['5uA30OsKdEY'],
                    youtubeShort: [],
                },
                demo3: {
                    id: 3,
                    name: 'FÜNF HEXEN DEMO #3',
                    date: '27 Apr 2025',
                    event: 'M3 2025 Frühling',
                    booth: 'https://kyousou-gakudan.booth.pm/items/6853757',
                    tracks: {
                        t1: 'Witch of True (Short ver)',
                        t2: 'Witch of Value (Short ver)',
                        t3: 'Witch of Creation (Short ver)',
                    },
                    youtube: [],
                    youtubeShort: ['1P01VrLK4VE', '1CPeTWlhcm0', 'eTLE3KYnT90', '6lNMg9CFyys'],
                },
            }
        },
        distribution: {
            pageName: 'Distribution',
            description: 'Distribution Links',
            streaming: 'Streaming',
            etc: 'ETC',
            goToAlbum: 'Move to the album page',
            cautionsToDlSale: 'Cautions to DL sale',
        },
        notFound: {
            pageName: '404 not found',
            description: '404 not found. This page is not exist. - Lunatic Tone Orchestra',
            returnToHome: 'Return to the top page',
        },
        language: {
            ja: '日本語',
            en: 'English',
        },
        soundPlayer: {
            play: 'Play',
            pause: 'Pause',
            stop: 'Stop',
            save: 'Download',
            volume: 'Volume',
            seek: 'Seek bar',
        },
        shop: {
            // shop
            akibao: 'Akibao',
            melonbooks: 'Melon books',
            amazon: 'Amazon',
            diskUnion: 'Disk Union',
            // dl
            bandcamp: 'Bandcamp',
            booth: 'BOOTH',
            dlSiteCom: 'DLsite',
            gyutto: 'Gyutto.com',
            melonbooksDl: 'Melon books DL',
            mucome: 'mucome',
            // streaming
            spotify: 'Spotify',
            appleMusic: 'Apple Music',
            lineMusic: 'LINE MUSIC',
            awa: 'AWA',
            kkBox: 'KKBOX',
            towerRecordsMusic: 'TOWER RECORDS MUSIC',
            amazonMusicUnlimited: 'Amazon Music Unlimited',
            utaPass: 'UtaPass',
            dHits: 'd Hits',
            youtubeMusic: 'YouTube Music',
            rakutenMusic: 'RAKUTEN MUSIC',
            deezer: 'Deezer',
            anghami: 'Anghami',
            jioSaavn: 'JioSaavn',
            mixcloud: 'Mixcloud',
            pandora: 'Pandora',
            soundCloud: 'SoundCloud',
            unitedMediaAgency: 'United Media Agency',
            yandexMusic: 'Yandex Music',
            // dl(narasu)
            iTunesStore: 'iTunes Store',
            recochoku: 'Recochoku',
            amazonDigitalMusicStore: 'Amazon Digital Music Store',
            dwangoJp: 'Dwango.jp',
            dMusic: 'd Music',
            musicStore: 'Music Store',
            animeloMix: 'animelo mix',
            // etc
            facebookMusicStamp: 'Facebook Music Stamp',
            instagramMusicStamp: 'Instagram Music Stamp',
            gracenote: 'Gracenote',
            otoraku: 'OTORAKU',
            popo: 'POPO',
            shazam: 'Shazam',
            tikTok: 'TikTok',           
        },
        snsName: {
            twitter: 'Twitter',
            instagram: 'Instagram',
            soundCloud: 'SoundCloud',
            youTube: 'YouTube',
            niconico: 'Niconico',
            line: 'LINE',
            faceBook: 'FaceBook',
            threads: 'Threads',
            bluesky: 'Bluesky',
            tikTok: 'TikTok',
            share: 'Share on {sns}.',
            copy: 'Copy URL',
            copySuccess: 'Succeed to copy URL',
            copyError: 'Failed to copy URL',
            openInstagram: 'View this post on Instagram.',
            openTwitter: 'View timeline on Twitter.',
        },
        common: {
            composition: 'Composition',
            jacket: 'Jacket',
            menu: 'Menu',
            close: 'Close',
        },
        aboutSite: {
            pageName: 'About this site.',
            description: 'About this site. - Lunatic Tone Orchestra',
            data: {
                aboutLyrics: 'About lyrics, poems and images',
                aboutLyricsDesc: `The lyrics and poetry of our band and the content of the images are fictional.<br>
                The events, countries, lands, names, persons, goods, corporations, associations, symbols, etc., and the names thereof, as depicted in the songs, jackets, lyric cards, website and other poems and images are fictitious. Any similarity or coincidence with any real event, country, land, name, person, commodity, corporation, entity, symbol, or other is entirely coincidental and unintentional.`,
                aboutLink: 'About Links',
                aboutLinkDesc: `This site and its published contents may be freely linked to. However, links from sites that are offensive to public order and morals are not permitted.<br>
                In addition, in any case where this site links to a third party site or a third party site links to this site, the content of the third party site is managed and operated under the responsibility of the third party, and we are not responsible for any inconvenience or damage caused by the use of such third party site.`,
                aboutDistribution: 'Streaming and Download Sales',
                aboutDistributionDesc: `Streaming and some downloads are distributed through distributors to various sites, so there is a possibility that there are other distribution sites that we are not aware of.<br>
                In addition, please note that the price of downloads sold by download vendors other than BOOTH, Bandcamp, and each doujin-kei store is not the price we set, so there may be differences in prices and accompanying images from site to site.`,
                banner: 'Banner',
                bannerUrl: 'https://kyousou-gakudan.com/banner/banner.png',
                contact: 'Contact us',
                contactDesc: `Email Address: {mail}<br>
                {twitterSnsName}: <a class="link" href="{twitterUrl}" target="_blank" title="@{twitterId}">@{twitterId}</a>
                `,
            }
        },
    }
};